export default "__VITE_ASSET__CjdhHTGY__"